import { AdvanceShareCodeResponse } from '@commerce-webcomponents/sdk';
import type { ButtonTheme } from '@nextgen-web-framework/all';
import { ShareMessage } from '../../SocialLinks/types/propTypes';

interface ButtonProps {
  disabled?: boolean;
  title?: string;
  theme?: ButtonTheme;
}
export enum RegistrationType {
  REQUIRED = 'REQUIRED',
  OPTIONAL = 'OPTIONAL',
}
export interface SocialShareLinkProps {
  linkProps?: AdvanceShareCodeResponse;
  /**
   * @deprecated `registrationType` prop has been deprecated because now it is picked from config and managed by E2E */
  registrationType?: RegistrationType;
  buttonProps?: ButtonProps;
  isCustomUrl?: boolean;
  shareTitleContent?: string;
  showDescription?: boolean;
  shareDescriptionsContent?: string;
  shareTextMessage?: ShareMessage;
  shareUrl?: boolean;
  shareRestrictions?: boolean;
  shareDrawer?: boolean;
  shareTitle?: boolean;
  customClass?: string;
}
